import { IconOpenPreview } from '@components/icons/open-preview';
import { Menu } from '@components/menu';
import { useScopedTranslate } from '@locale/translate';

import { previewEmailLocale, PreviewEmailProps } from './email-preview';
import { usePreviewEmailModal } from './email-preview-modal';

// Disabled until its preview props resolve, so it never pops into an
// already-open menu (callers fetch lazily once the menu mounts it).
// Callers may also disable it (with a tooltip) while the action is unconfigured.
export const PreviewEmailMenuItemView = ({
  previewProps,
  isDisabled,
  tooltip,
}: {
  previewProps?: PreviewEmailProps;
  isDisabled?: boolean;
  tooltip?: string;
}) => {
  const { t } = useScopedTranslate(previewEmailLocale);
  const showPreviewModal = usePreviewEmailModal();

  return (
    <Menu.Item
      label={t('previewEmail')}
      icon={<IconOpenPreview />}
      isDisabled={!previewProps || isDisabled}
      tooltip={tooltip}
      onSelect={() => previewProps && showPreviewModal(previewProps)}
    />
  );
};
